import { StringMap } from '@/shared/utils/map'

export function createObservable(
  obj: StringMap<any>,
  name: PropertyKey,
  callback: (name: PropertyKey, value: any) => void
): boolean | any {
  let _value: any

  return Object.defineProperty(obj, name, {
    get(): any {
      return _value
    },
    set(newValue): void {
      if (Array.isArray(newValue)) {
        newValue = new Proxy(newValue, {
          set(target: any, p: string | number | symbol, value: any): boolean {
            const oldValue = target.length

            target[p] = value

            // Check if the array has been modified
            if (newValue.length !== oldValue) {
              callback(name, value)
            }

            return true
          },
        })
      }

      callback(name, newValue)

      _value = newValue
    },
    configurable: true,
    enumerable: true,
  })
}
